<template>
  <div>
    <div class="tariffs-title tariff-section-margin">{{ $t('packages.additionalPayments.title') }}</div>
    <div class="additional-payments-list">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="additional-payment"
        :class="{ 'additional-payment-first': index === 0 }"
      >
        <div class="additional-payment-name">{{ item.name }}</div>
        <div class="additional-payment-price">{{ item.price }}</div>
      </div>
    </div>
    <div class="additional-payments-note">{{ $t('packages.additionalPayments.note') }}</div>
  </div>
</template>

<script>
export default {
  name: "AdditionalPayments",
  computed: {
    items() {
      return [0, 1, 2].map((index) => ({
        name: this.$t(`packages.additionalPayments.items[${index}].name`),
        price: this.$t(`packages.additionalPayments.items[${index}].price`),
      }));
    },
  },
}
</script>

<style scoped>

.tariffs-title {
  font-size: 28px;
  font-weight: bold;
}

@media screen and (min-width: 768px) {
  .tariffs-title {
    font-size: 32px;
  }
}

@media screen and (min-width: 1024px) {
  .tariffs-title {
    font-size: 40px;
  }
}

.tariff-section-margin {
  margin-top: 40px;
}

@media screen and (min-width: 768px) {
  .tariff-section-margin {
    margin-top: 60px;
  }
}

@media screen and (min-width: 1024px) {
  .tariff-section-margin {
    margin-top: 80px;
  }
}

.additional-payments-list {
  margin-top: 28px;
}

@media screen and (min-width: 768px) {
  .additional-payments-list {
    margin-top: 42px;
  }
}

@media screen and (min-width: 1024px) {
  .additional-payments-list {
    margin-top: 56px;
  }
}

.additional-payment {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid #000000;
  padding: 16px 0;
}

@media screen and (min-width: 768px) {
  .additional-payment {
    padding: 24px 0;
  }
}

@media screen and (min-width: 1024px) {
  .additional-payment {
    padding: 32px 0;
  }
}

.additional-payment-first {
  border-top: 1px solid #000000;
}

.additional-payment-name {
  font-size: 18px;
}

@media screen and (min-width: 768px) {
  .additional-payment-name {
    font-size: 22px;
  }
}

@media screen and (min-width: 1024px) {
  .additional-payment-name {
    font-size: 24px;
  }
}

.additional-payments-note {
  margin-top: 20px;
  max-width: 1300px;
  font-size: 16px;
  color: #8a8a8a;
}

@media screen and (min-width: 768px) {
  .additional-payments-note {
    margin-top: 30px;
    font-size: 20px;
  }
}

@media screen and (min-width: 1024px) {
  .additional-payments-note {
    margin-top: 40px;
    font-size: 22px;
  }
}

.additional-payment-price {
  font-size: 18px;
  font-weight: bold;
  flex-shrink: 0;
}

@media screen and (min-width: 768px) {
  .additional-payment-price {
    font-size: 22px;
  }
}

@media screen and (min-width: 1024px) {
  .additional-payment-price {
    font-size: 24px;
  }
}

</style>
